import { useEffect, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { usageTracker } from '../utils/usageTracker';
import { TicketInfoPanel } from '../components/TicketInfoPanel';
import { TicketThreadViewerWrapper } from '../components/TicketThreadViewerWrapper';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketDetails() {
  const [isInfoPanelOpen, setIsInfoPanelOpen] = useState(false);
  const [isAttachmentsPanelOpen, setIsAttachmentsPanelOpen] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    usageTracker.track('Customer Portal App', 'Page Viewed', {
      screen: 'ticket-details'
    });
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: "1",
    blockSize: "100%",
    children: [/*#__PURE__*/_jsx(TicketInfoPanel, {
      isMobile: isMobile,
      isInfoPanelOpen: isInfoPanelOpen,
      setIsInfoPanelOpen: setIsInfoPanelOpen
    }), /*#__PURE__*/_jsx(TicketThreadViewerWrapper, {
      setIsInfoPanelOpen: setIsInfoPanelOpen,
      isAttachmentsPanelOpen: isAttachmentsPanelOpen,
      setIsAttachmentsPanelOpen: setIsAttachmentsPanelOpen
    })]
  });
}